import Text from '@cartwhl/ui/base/Text';

import { CDN } from 'consts';

import MarketingMedia from '../../MarketingMedia';
import { posterForVideoSource } from '../../marketing-media';
import { publicPageGutters } from '../../public-page-gutters';

const dataItems = [
  {
    title: 'Behavioral &\n social prediction',
    description: 'Understanding intent, affect, and non-verbal communication',
    videoUrl: `${CDN}05_data_page/02_behavioral_socialV2.webm`,
  },
  {
    title: 'Robotics\n training data',
    description: 'Human motion for learning, imitation, and interaction',
    videoUrl: `${CDN}05_data_page/03_robotics_training_data.webm`,
  },
  {
    title: 'Sports motion analysis',
    description: 'Performance, biomechanics, and movement efficiency',
    videoUrl: `${CDN}05_data_page/04_sportsV2.webm`,
  },
  {
    title: 'World & interaction models',
    description: 'Motion priors for simulated environments and agents',
    videoUrl: `${CDN}v2_data_05_world_models.webm`,
  },
];

export default function DataItemsSection() {
  return (
    <section className="pb-(--vertical-spacing)">
      <div className={publicPageGutters}>
        <div className="grid gap-4 md:grid-cols-2 lg:grid-cols-4">
          {dataItems.map((item, index) => (
            <div key={index} className="flex flex-col gap-7 lg:gap-12">
              <MarketingMedia
                media={{
                  type: 'video',
                  src: item.videoUrl,
                  mimeType: 'video/webm',
                  description: `${item.title.replace(/\s+/g, ' ')} preview.`,
                  poster: posterForVideoSource(item.videoUrl),
                }}
                className="aspect-square rounded-2xl"
              />

              <div className="flex flex-col gap-5 lg:gap-7">
                <Text
                  as="h3"
                  variant="web/body/medium/lg"
                  lg:variant="web/body/medium/xl"
                  className="whitespace-pre-line"
                >
                  {item.title}
                </Text>
                <Text
                  as="p"
                  variant="web/body/medium/md"
                  lg:variant="web/body/medium/24"
                  className="text-tertiary lg:pr-10"
                >
                  {item.description}
                </Text>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
